import { ComponentProps } from "react";
import { Link } from "router2";

import { isWebPath, toWebPath } from "~/hook/base/useIsWeb.ts";
import { PreloadLink } from "~/ui/base/PreloadLink.tsx";

interface AppLinkProps extends ComponentProps<typeof Link> {
  preload?: boolean;
}

export const AppLink = ({
  pathname,
  preload = true,
  ...props
}: AppLinkProps) => {
  const targetPathname =
    isWebPath() && !pathname.startsWith("/web")
      ? toWebPath(pathname)
      : pathname;

  if (preload) {
    return <PreloadLink {...props} pathname={targetPathname} />;
  }

  return <Link {...props} pathname={targetPathname} />;
};
